export default {
  // Page title
  title: "Push Record",
  
  // Search form
  searchForm: {
    pushTime: "Push Time",
    pushTimePlaceholder: "Please select time range",
    memberAccount: "Push Member",
    memberAccountPlaceholder: "Please enter",
    pushType: "Push Type",
    pushTypePlaceholder: "Get the main type of push for this message",
    memberType: "Member Type",
    memberTypePlaceholder: "Please select",
    status: "Status",
    statusPlaceholder: "Please select",
    search: "Query",
    reset: "Reset"
  },
  
  // Table column titles
  table: {
    memberAccount: "Push Member",
    pushType: "Push Type",
    memberType: "Member Type",
    pushTitle: "Push Title",
    pushContent: "Push Content",
    pushTime: "Push Time",
    status: "Status"
  },
  
  // Status
  status: {
    success: "Success",
    failed: "Failed"
  },
  
  // Pagination
  pagination: {
    total: "Total {total} records",
    pageInfo: "Page {currentPage}/{totalPages}",
    itemsPerPage: "items/page",
    jumpTo: "Jump to",
    page: "page"
  },
  
  // Messages
  messages: {
    fetchDataFailed: "Failed to fetch data",
    noData: "No data",
    timeRangeExceeded: "Query time range cannot exceed 1 month, please reselect."
  }
};
